import { prepCurrentPath } from '~/helpers/routing';

import PATHS, { AURI_PATH } from './constants/paths';
import { MIN_IMAGE_SIZE, MAX_IMAGE_SIZE } from './constants/media';

export const getCurrentPath: () => string = prepCurrentPath(
  PATHS,
  AURI_PATH,
  PATHS.encode
);

export const getImageDims = async (
  file: File
): Promise<{ width: number; height: number }> => {
  const image = new Image();

  image.src = URL.createObjectURL(file);
  await image.decode();

  return image;
};

export const validateImageDims = async (image: File): Promise<boolean> => {
  const { width, height } = await getImageDims(image);

  return (
    Math.min(width, height) > MIN_IMAGE_SIZE &&
    Math.max(width, height) < MAX_IMAGE_SIZE
  );
};
